import { componentMapper, constantStrings } from '@/services/constants'
import { v4 as uuidV4 } from 'uuid'
import { GlobalVars } from '@/services/globals'
import { hideMessage } from '@/services/utils'
import { extractCustomFields } from '@/services/customFields'
import store from '../../store'
import { updateAgentInfoInLocalStorage } from '@/services/liveAgent/utils/utils'
import cloneDeep from 'lodash/cloneDeep'
import { processCustomPayload } from '../customPayload'
import { getUrlData }  from '../../services/urlDetails/urlInfo'

export function botResponseMessageParser(messages, isLastBotResponse, isAgentResponse = false, isCallbackEventTriggered = false) {
  const toHide = isAttachmentEmptyInAgentResponse(messages)
  const chatBlock = {
    isUser: false,
    isAgent: isAgentResponse,
    requestId: messages.requestId,
    messages:
      messages?.attachments?.map(message => {
        if (componentMapper[message.type][0]) {
          return {
            messageId: uuidV4(),
            requestId: messages.requestId,
            type: componentMapper[message.type][0],
            hide: toHide || hideMessage(
              message,
              componentMapper[message.type][0],
              isLastBotResponse
            ),
            messageValue: message.attachment,
            timestamp: parseInt(messages.timestamp),
            isUser: false
          }
        }
      }) || [],
    timestamp: parseInt(messages.timestamp)
  }
  if (messages.customPayload) {
    processCustomPayload(messages)
  }

  if (isAgentResponse){
    const avatar = messages?.agentInfo?.avatar || store.state.agentInfo.avatar || `${GlobalVars.$cdn}/images/agent_default.svg`
    const displayName = messages?.agentInfo?.displayName || store.state.agentInfo.displayName
    chatBlock.agentInfo = { avatar, displayName }
    if (displayName && messages?.agentDesk?.toUpperCase() === constantStrings.SALESFORCE) updateAgentInfoInLocalStorage({ displayName, avatar })
  }
  if (messages.customFields && messages.customFields.length) {
    chatBlock.messages = [
      ...chatBlock.messages,
      ...processCustomFields(messages, isLastBotResponse, isCallbackEventTriggered)
    ]
  }
  const multiSourceMessageIndex = chatBlock?.messages?.findIndex((message)=>{
    return message.type === 'MultiSource'
  })
  if (multiSourceMessageIndex !=-1 && store.getters?.isDynamicSourcesDisabled) {
    const multiSourceMessage = chatBlock.messages?.[multiSourceMessageIndex]
    if (multiSourceMessage) {
      const multiSources = multiSourceMessage.messageValue.multipleSourceDetails
      let newText = ' '
      multiSources.forEach((source)=>{
        newText += ("\n"+source.text)
      })
      const newMessage = cloneDeep(multiSourceMessage)
      if(!newMessage.messageValue.text) {
        newMessage.messageValue.text = 'Sources'
      }
      delete newMessage.messageValue['multipleSourceDetails']
      const { text } = newMessage.messageValue
      const message = {
        ...newMessage,
        messageId: uuidV4(),
        messageValue: {
          ...newMessage.messageValue,
          isReviewEnabled: false,
          attachmentResponseType: 'ANSWER_AI_RESPONSE',
          type: 'ai.msg.domain.responses.core.Text',
          text: text + newText
        },
        type: "TextResponse",
        showInCollapsedView: true
      }
      chatBlock.messages.splice(multiSourceMessageIndex+1,0,message)
    }
  }
  else if(multiSourceMessageIndex !=-1 && !store.getters?.isDynamicSourcesDisabled) {
    const multiSourceMessage = chatBlock.messages?.[multiSourceMessageIndex]
    if (multiSourceMessage) {
      const multiSources = multiSourceMessage.messageValue.multipleSourceDetails
      fetchMultiSourceLogo(multiSources)
    }
  }
  return chatBlock
}

function processCustomFields(messages, isLastBotResponse, isCallbackEventTriggered) {
  return extractCustomFields(messages, isLastBotResponse, isCallbackEventTriggered) || []
}

function isAttachmentEmptyInAgentResponse(messages) {
  return (!messages?.attachments?.length && messages.ownerType === constantStrings.AGENT)
}

function fetchMultiSourceLogo(multiSources) {
  let data
  if (multiSources?.length) {
      const urlArr = multiSources.map(option => option.text)
      data = getUrlData({ requestBody: urlArr })
  } 

  let sourceObj = {}
    data
      ?.then(info => {
        multiSources?.forEach((option,index)=>{
          const value = info?.[index]?.value
          const logo = value?.logo
          const url = option.text
          sourceObj[url] = logo
        })
        const sourceMap = store.state.multiSourceLogoObj
        const newSourceMap = {...sourceMap,...sourceObj}
        Object.keys(sourceObj)?.length > 0 && (store.state.multiSourceLogoObj = newSourceMap)
      })
      ?.catch(err => {
        console.log(err)
      })
  }
